import React, { useMemo } from 'react';
import DataTable from '@/components/General/DataTable';
import generalStyles from '@/components/General/Styles.module.scss';
import styles from './TPADetails.module.scss';

const TPA_TYPE_LABELS = {
    niq_partner: 'NIQ Partner',
    broker: 'Broker',
    consultant: 'Consultant',
    other: 'Other',
};

export function TPADetails({ userDetails }) {
    const tpaColumns = useMemo(
        () => [
            {
                Header: 'Provider Company',
                accessor: 'providerCompany',
                className: generalStyles.tableCell,
            },
            {
                Header: 'TPA Type',
                accessor: 'tpaType',
                className: generalStyles.tableCell,
                Cell: ({ value }) => TPA_TYPE_LABELS[value] || value,
            },
            {
                Header: 'Link',
                accessor: 'tpaLink',
                className: generalStyles.tableCell,
                Cell: ({ value }) =>  value || 'N/A'
            },
            {
                Header: 'Start Date',
                accessor: 'startDate',
                className: generalStyles.tableCell,
            },
            {
                Header: 'End Date',
                accessor: 'endDate',
                className: generalStyles.tableCell,
            },
        ],
        []
    );

    return (
        <>
            {userDetails?.consultantDetails && (
                <>
                    <h3>TPA Details</h3>
                    <div className={styles.tableContainer}>
                        <DataTable
                            data={userDetails.consultantDetails}
                            columns={tpaColumns}
                            noDataDescription="No TPA details found"
                            withPagination={false}
                        />
                    </div>
                </>
            )}
        </>
    );
}
